import {
  CHECKOUT_EVENT_NAMES,
  checkoutBusinessLogger,
  SGM_PAY_METHOD,
  SGM_PAYMENT_TIME,
  SGM_TRACK_MAIN_TYPE,
  SGM_TRACK_TYPE,
  SGM_TRACK_TYPE_MESSAGE,
} from '@/utils/logger/instance/checkoutBusinessLogger';

/**
 * @file sgmTrack.ts
 * @description 定义与结算、支付相关的埋点追踪类型、主类型、支付方式、追踪上传参数等常量与接口，供结算流程的埋点统计与异常追踪上报使用。
 */

/**
 * 埋点追踪参数对象类型
 */
export interface SGMTrack {
  // 埋点主类型（区分API异常或JS异常等）
  type: SGM_TRACK_MAIN_TYPE;
  //发起支付的时机： 首次支付/二次支付
  paymentTime?: SGM_PAYMENT_TIME;
  // 详细追踪类型（可选）
  detailCode?: SGM_TRACK_TYPE;
  payMethod?: typeof SGM_PAY_METHOD;
  // 支付后，查询是否支付成功
  retryAttempts?: number;
  eventName?: string;
}

/**
 * 系统追踪参数类型（可选）
 */
export interface SYSTEM_TRACK_VO {
  status?: boolean;
  value?: number;
  message: IMESSAGEVO;
}

export interface IMESSAGEVO {
  traceId?: string;
  code?: string;
  orderId?: string;
  error?: string;
}

export interface IMESSAGEPAYLOADVO extends IMESSAGEVO {
  message: string;
}

/**
 * 提交埋点追踪数据
 * @param params 追踪主要参数
 * @param systemParams 系统追踪参数（可选）
 */
export const sgmBizTrackSubmit = (params: SGMTrack, systemParams: SYSTEM_TRACK_VO) => {
  const detailCode = params.detailCode as keyof typeof SGM_TRACK_TYPE_MESSAGE;
  const message: string = SGM_TRACK_TYPE_MESSAGE[detailCode] ?? '';
  try {
    // 仅上传 IMESSAGEVO 字段，且空字段不上传
    const messageKeys: Array<keyof IMESSAGEPAYLOADVO> = [
      'traceId',
      'code',
      'message',
      'orderId',
      'error',
    ];
    const messagePayload: Partial<IMESSAGEPAYLOADVO> = {};
    messageKeys.forEach((key) => {
      if (key !== 'message') {
        const value = systemParams?.message?.[key];
        if (value !== undefined && value !== null && value !== '') {
          messagePayload[key] = value;
        }
      } else {
        messagePayload[key] = message;
      }
    });

    const categoryParams: any = {
      type: params.type,
      paymentTime: params.paymentTime,
      detailCode: params.detailCode,
      payMethod: params.payMethod,
      retryAttempts: params.retryAttempts,
    };

    checkoutBusinessLogger({
      eventName: params?.eventName || CHECKOUT_EVENT_NAMES.CHECKOUT_PAGE_ERROR,
      category: {
        ...categoryParams,
      },
      message: { ...messagePayload },
    });
  } catch (error) {
    console.log('checkout sgmBizTrack error: ', error);
  }
};
